import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google'

// import { makeStyles } from '@mui/material/styles'


import {
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  CircularProgress,
} from '@mui/material'
import { useMutation } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import { useAuthentication } from '../hooks/useAuthentication'

import logo from '../logo.svg'
import { MailOutline } from '@mui/icons-material'
import LoginForm from './LoginForm'
import OtpLoginForm from './OtpLoginForm'

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '989851693832-h634t1i9n1pfquf1j0rovgar5bg1p7fs.apps.googleusercontent.com'

const AUTH_GOOGLE = gql`
  mutation authGoogle($input: AuthInput!) {
    authGoogle(input: $input) {
      token
      name
      user {
        first_name
        last_name
        email
        role
        majlis
        department {
          id
          name
        }
      }
    }
  }
`

// const useStyles = makeStyles((theme) => ({
//   logo: {
//     maxWidth: '100%',
//     maxHeight: '100%',
//   },
// }))

const Login: React.FunctionComponent<RouteComponentProps> = ({
  history,
  match,
}) => {
  const { authState, signIn } = useAuthentication();
  // const classes = useStyles()
  const [authGoogle, googleAuthResp] = useMutation(AUTH_GOOGLE)

  const handleLoginSuccess = (accessToken) => {
    authGoogle({
      variables: { input: { accessToken } },
    })
  }

  if (googleAuthResp.error) {
    console.error(googleAuthResp.error)
    return <p>ERROR occurred</p>
  }
  if (googleAuthResp.data) {
    const {
      authGoogle: { token },
    } = googleAuthResp.data

    if (token) {
      signIn(token)
    }
  }

  if (authState.authUser && authState.authUser.id !== '') {
    return <Redirect to="/panel" />
  }



  return (
    <Box
      component="main"
      sx={{
        maxWidth: 440,
        mx: 'auto',
        px: { xs: 2, sm: 3 },
        pb: { xs: 4, sm: 6 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 2, sm: 2.5 },
        mt: { xs: 4, sm: 6, md: 8 },
      }}
    >
      <Card raised sx={{ width: '100%' }}>
        <CardHeader
          avatar={
            <Avatar aria-label="Ahmadiyya Sverige" src={logo} />
          }
          title="Voucher Handling System"
          subheader="Islam Ahmadiyya Församling, Sverige"
        />
        <CardContent>
          {googleAuthResp.loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />
            </Box>
          ) : (
            <GoogleOAuthProvider clientId={clientId || ''}>
              <CustomLoginButton onLoginSuccess={handleLoginSuccess} />
            </GoogleOAuthProvider>
          )}
        </CardContent>
      </Card>

      <Box sx={{ color: 'text.secondary', fontSize: { xs: '0.85rem', sm: '1rem' } }}>
        — OR —
      </Box>

      <Card raised sx={{ width: '100%' }}>
        <CardHeader
          avatar={<Avatar aria-label="Ahmadiyya Sverige" src={logo} />}
          title="Voucher Handling System"
          subheader="Sign in with a one-time code sent to your email"
        />
        <CardContent>
          <OtpLoginForm />
        </CardContent>
      </Card>

      {window.location.hostname !== 'vhs.ahmadiyya.se' && (
        <>
          <Box sx={{ color: 'text.secondary', fontSize: { xs: '0.85rem', sm: '1rem' } }}>
            — OR —
          </Box>
          <Card raised sx={{ width: '100%' }}>
            <CardHeader
              avatar={<Avatar aria-label="Ahmadiyya Sverige" src={logo} />}
              title="Voucher Handling System"
              subheader="Login with your email and password"
            />
            <CardContent>
              <LoginForm />
            </CardContent>
          </Card>
        </>
      )}
    </Box>
  )
}

const CustomLoginButton = ({ onLoginSuccess }) => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      onLoginSuccess(tokenResponse.access_token)
    },
    onError: (error) => {
      console.error('[Login failed]: ', error)
    },
  })

  return (
    <Button
      variant="contained"
      startIcon={<MailOutline />}
      onClick={() => login()}
    >
      Login with Gmail
    </Button>
  )
}

export default Login
